import { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Stack } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import LockIcon from '@mui/icons-material/Lock';
import { AutoCompleteSelectUI, FormLabelUI, TooltipUI } from '../Interface';
import folderTemplateService from '../../service/folderTemplate.service';
import { generateAutocompleteItems } from '../../utils/helper';

const FolderTemplateImportDialog = ({ open, handleClose, handleImportFolder }) => {
  const [templateData, setTemplateData] = useState([]);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedTemplate(null);
      setTemplateData([]);
      setTemplateOptions([]);
      return;
    }

    getTemplates();
  }, [open]);

  const getTemplates = () => {
    folderTemplateService.getTemplates().then((data) => {
      setTemplateData(data);
      setTemplateOptions(generateAutocompleteItems(data, 'name', 'id'));
    });
  };

  const folderTemplateItems = templateData.find((item) => item.id === selectedTemplate)?.folderTemplateItem ?? [];

  const handleCreate = () => {
    handleImportFolder(folderTemplateItems);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Sablon importálás</DialogTitle>
      <DialogContent>
        <Box mt={1}>
          <AutoCompleteSelectUI
            variant="outlined"
            size="small"
            label={<FormLabelUI text="Sablonok" />}
            dataset={templateOptions}
            onChange={(_e, newVal) => setSelectedTemplate(newVal?.value ?? null)}
            selectedValue={selectedTemplate}
          />

          {folderTemplateItems.length > 0 && (
            <Box mt={2}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                Létrehozandó mappák
              </Typography>

              {folderTemplateItems.map((item) => (
                <Stack
                  key={item.id}
                  direction="row"
                  justifyContent="space-between"
                  p={1}
                  mb={0.5}
                  borderRadius={1}
                  border={1}
                  borderColor="divider"
                >
                  <Stack direction="row" spacing={1}>
                    <FolderIcon fontSize="small" sx={{ color: item.color }} />
                    <Typography variant="body2">{item.name}</Typography>
                  </Stack>
                  {item.protected && (
                    <TooltipUI title="Védett mappa" arrow>
                      <LockIcon color="error" fontSize="small" />
                    </TooltipUI>
                  )}
                </Stack>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Mégse</Button>
        <Button onClick={handleCreate} variant="contained" disabled={!folderTemplateItems.length}>
          Létrehozás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderTemplateImportDialog;
